﻿import "../app";
import { IResourceOf } from "../interfaces/iFqs"
export interface Compliment extends IResourceOf<Compliment>, ComplimentData { }

export interface ComplimentData {
    Content: string;
}